module.exports = __webpack_public_path__ + "static/media/tour1.42fc1692.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/america-off-balance/tour1.jpg
// module id = 295
// module chunks = 0